import type { Patient } from '../../../advanced-search/advanced-search-hook'

import { useQuery } from '@tanstack/react-query'
import _ from 'lodash'
import { MdOutlineFolderShared } from 'react-icons/md'
import { RiFolderTransferLine } from 'react-icons/ri'
import { Link, useNavigate } from 'react-router-dom'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import statuses from 'shared_src/dictionaries/episodeOfCare/statuses'

import http from '../../../../lib/http'
import { useAppSelector } from '../../../../store'
import * as Table from '../../../claim-history/simple-table'
import { NoDataPlaceHolder } from '../../../PatientFolder/behavioral/components'
import { ContextMenuButton } from '../../../shared/ContextMenu'
import FriendlyDate from '../../../shared/Date/FriendlyDate'
import * as Sidebar from '../components/index'
import styles from '../patient-search/patient-search.module.css'

type QueryKeys = [ string, QueryParams ]

interface QueryParams {
  anyName: string
  sortBy: string
  sortDir: string
  managingOrg: string
  scope: string
  status: StatusesEnum
  count: number
  clientName: string
}

interface Response {
  data: Patient[]
}

enum StatusesEnum {
  'all' = 'all',
  'planned' = 'planned',
  'onhold' = 'onhold',
  'waitlist' = 'waitlist',
  'active' = 'active',
  'finished' = 'finished',
  'cancelled' = 'cancelled',
  'entered-in-error' = 'entered-in-error'
}

export function OpenEncounters (): JSX.Element {
  const navigate = useNavigate()
  const { clients } = useAppSelector(state => state.globalVars)
  const values = {
    anyName: '',
    scope: 'all',
    status: StatusesEnum.all,
    open: true,
    count: 99,
    clientName: 'all',
    sortBy: 'lastName',
    sortDir: 'asc',
    managingOrg: 'all'
  }

  const { data: patientsData, isFetched } = useQuery<Response, unknown, Response, QueryKeys>({
    queryKey: [ 'patient-search', values ],
    queryFn: async () => {
      const searchParams = new URLSearchParams()

      Object.keys(values).map((key) => {
        const value = values[key as keyof QueryParams].toString()

        if (value) {
          searchParams.append(key, value.trim().replaceAll(',', ''))
        }
        return null
      })

      return await http
        .getRequest('/patients_search', searchParams, { clientName: false })
        .then((data: Response) => {
          return data
        })
    }
  })

  return (
    <>
      <Sidebar.Header>Open Encounters</Sidebar.Header>
      <Sidebar.Wrapper>
        {(patientsData?.data?.length ?? 0) <= 0 && isFetched && (
          <NoDataPlaceHolder
            title='There are no Open Encounters to display'
            className='bg-transparent'
          />
        )}

        <Table.ContainerMeasureProvider>
          <Sidebar.Cards>
            {patientsData?.data?.map(({ firstName, lastName, id, _clientName, birthDate, status }) => (
              <Sidebar.Card key={id}>
                <Link
                  title='Open Patient Folder'
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                  to={`/patient/${_clientName}/${id}/assessment/igao`}
                >
                  <p className={styles.patientName}>{firstName} {lastName}</p>

                  <p style={{ color: '#9d98a4', lineHeight: '21px' }}>{clients?.find((client) => client.clientName === _clientName)?.display}</p>

                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <p style={{ color: '#9d98a4', lineHeight: '21px' }}><FriendlyDate date={birthDate || ''} /></p>
                    <p style={{ color: '#9d98a4', lineHeight: '21px' }}>
                      {
                        status
                          ? _.find(statuses, x => x.value === status).label
                          : 'Unknown'
                      }
                    </p>
                  </div>
                </Link>

                <ContextMenuButton
                  actions={[
                    {
                      id: 'patient-holder',
                      icon: MdOutlineFolderShared,
                      label: 'Patient Folder',
                      onClick: () => {
                        navigate(`/patient/${_clientName}/${id}`)
                      }
                    },
                    {
                      id: 'care-plan',
                      icon: RiFolderTransferLine,
                      label: 'Care Plan',
                      onClick: () => {
                        navigate(`/patient/${_clientName}/${id}/assessment/igao`)
                      }
                    }
                  ]}
                  onClose={() => ({})}
                />
              </Sidebar.Card>
            ))}
          </Sidebar.Cards>
        </Table.ContainerMeasureProvider>
      </Sidebar.Wrapper>
    </>
  )
}
